import React from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'

import { ClipPathOuter } from 'components/block/Profile/ProfileMain/profileMain.styled'
import { MainLayout } from 'components/designSystem/layout/MainLayout/MainLayout'
import notFound from 'components/designSystem/svg/lighthouse-search.svg'
import { FilterSvg } from 'components/designSystem/svgr/FilterSvg'
import { photoRatingSettingsPath } from 'components/page/PhotoRatingSettings/PhotoRatingSettings.paths'
import { push } from 'functions/router'

export const NotFound = () => {
  const dispatch = useDispatch()

  const handlePrimaryButtonClick = () => {
    dispatch(push(photoRatingSettingsPath))
  }

  return (
    <Parent>
      <MainLayout
        title={
          <FormattedMessage
            id="not.found.title"
            defaultMessage="Ничего не найдено"
          />
        }
        description={
          <FormattedMessage
            id="not.found.description"
            defaultMessage="Людей с указанными параметрами профиля не нашлось. Попробуй изменить фильтры поиска."
          />
        }
        icon={<img src={notFound} width={200} height={200} />}
        backButtonVisible={false}
        onPrimaryButtonClick={handlePrimaryButtonClick}
        primaryButtonText={
          <InnerButton>
            <FilterSvg width={24} height={24} />
            <Text>
              <FormattedMessage
                id="change.filter.settings"
                defaultMessage="Изменить фильтры"
              />
            </Text>
          </InnerButton>
        }
        increasePaddingBottom={true}
        noBorder={true}
        wrapperStyle={{
          background: 'var(--background-surface-2)',
        }}
      />
    </Parent>
  )
}

const Parent = styled(ClipPathOuter)`
  width: 100%;
`

const InnerButton = styled.span`
  display: grid;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-8px);
  grid-gap: var(--spacing-8px);
  grid-auto-flow: column;
`

const Text = styled.span`
  position: relative;
  top: 1px;
`
